import { toast } from "sonner";

import { errorMessage, isPlanLimit } from "./api";
import { billingPath, orgIdFromPath } from "./billing";

// Toasts live outside the router, so the router registers its navigate
// function here once at startup (module state on purpose: there is exactly
// one router per page). Until then links fall back to a full page load.
let navigateTo: (to: string) => void = (to) => window.location.assign(to);

export function setNavigator(fn: (to: string) => void) {
  navigateTo = fn;
}

/** Navigates inside the app from outside the router (toast actions). */
export function goTo(to: string) {
  navigateTo(to);
}

/** One id for every plan-limit toast, so sonner updates it instead of stacking duplicates. */
export const PLAN_LIMIT_TOAST_ID = "plan-limit";

/** Shows the server's plan-limit message with an "Upgrade" action that opens the billing tab. */
export function showPlanLimitToast(err: Error) {
  const orgId = orgIdFromPath(window.location.pathname);

  toast.error(err.message, {
    id: PLAN_LIMIT_TOAST_ID,
    // long enough to reach the action
    duration: 8_000,
    action: orgId ? { label: "Upgrade", onClick: () => navigateTo(billingPath(orgId)) } : undefined,
  });
}

/**
 * The standard error toast. Plan-limit errors get the upgrade toast instead;
 * the global mutation handler shows the same toast id, so the two never stack.
 */
export function toastError(err: unknown, fallback?: string) {
  if (isPlanLimit(err)) {
    showPlanLimitToast(err);

    return;
  }

  toast.error(errorMessage(err, fallback));
}
